
import apiReq from '../commontools/api.js'
export function GetWaitApproveOrder(CommitCorpID) {
	var url = '/Order/GetWaitApproveOrder/' + CommitCorpID;
	return apiReq.get(url)
}
export function GetOrderByJson(corpid, start, end, salername, ordername, orderstate) {

	if (end != null) {
		end = new Date(new Date(end).getTime() + 24 * 60 * 60 * 1000);
	}

	var url = '/Order/GetOrderByJson/'; //+corpid+'/'+start+'/'+end+'/'+salername+'/'+ordername;
	var p = {
		'corpid': corpid,
		'start': start,
		'end': end,
		'salername': salername,
		'ordername': ordername,
		'orderstate': orderstate
	}
	// alert(url+JSON.stringify(p))
	return apiReq.get(url + JSON.stringify(p))
}
export function CommitOrder(OrderEnt) {

	var url = '/Order/CommitOrder/' + OrderEnt.OrderID + '/' + OrderEnt.CommitDate + '/' + OrderEnt.OrderState;
	return apiReq.get(url)
}
export function ApproveOrder(OrderEnt) {

	var url = '/Order/ApproveOrder/';
	let p = {
		'commitcorpid': OrderEnt.CommitCorpID,
		'orderid': OrderEnt.OrderID,
		'approveid': OrderEnt.ApproveID,
		'approvename': OrderEnt.ApproveName,
		'approvedate': OrderEnt.ApproveDate,
		'approvememo': OrderEnt.ApproveMemo,
		'orderstate': OrderEnt.OrderState,
	}
	return apiReq.get(url + JSON.stringify(p))
}
export function GetMyOrder(SalerID) {
	var url = '/Order/GetMyOrder/' + SalerID;
	return apiReq.get(url)
}
export function EditOrder(info) {
	var url = '/Order/EditOrder';
	var p = {
		data: info
	}
	return apiReq.post(url, p);
}
export function AddOrder(info) {

	var url = '/Order/AddOrder';
	var p = {
		data: info
	}
	return apiReq.post(url, p);
}
export function DelOrder(orderid) {

	var url = '/Order/DelOrder/'+orderid;
	return apiReq.get(url);
}
export function GetOrderByID(orderid) {

	var url = '/Order/GetOrderByID/'+orderid;
	return apiReq.get(url);
}
export function GetOrderByUserID(userid) {

	var url = '/Order/GetOrderByUserID/'+userid;
	return apiReq.get(url);
}
export function SaveOrderBookBranch(orderid,branchsjson){
	var url='/Order/SaveOrderBookBranch/'+orderid;
	var p = {
		data: branchsjson
	}
	return apiReq.post(url, p);
}
export default {
	GetWaitApproveOrder,
	CommitOrder,
	GetOrderByJson,
	ApproveOrder,
	GetMyOrder,
	AddOrder,
	EditOrder,
	DelOrder,
	GetOrderByID,
	GetOrderByUserID,
	SaveOrderBookBranch
}
